<template>
    <div class="p-4 rounded-xl border shadow max-w-md mx-auto">
        <h2 class="text-xl font-bold mb-4">🪙 Duelly Token Wallet</h2>

        <div v-if="publicKey" class="mb-2">
            <p class="text-sm duelly-primary">Wallet Address:</p>
            <code class="break-all text-xs duelly-primary">{{ publicKey }}</code>
        </div>

        <button
            v-if="!publicKey"
            @click="generateWallet"
            class="bg-blue-600 text-white px-4 py-2 rounded mt-2 w-full"
        >
            Create Wallet
        </button>

        <button
            v-if="publicKey"
            @click="airdropSol"
            class="bg-green-600 text-white px-4 py-2 rounded mt-2 w-full"
        >
            Airdrop 1 SOL (Devnet)
        </button>

        <p v-if="status" class="text-sm text-gray-600 mt-2">{{ status }}</p>
    </div>
</template>

<script setup>
import { clusterApiUrl, Connection, Keypair, LAMPORTS_PER_SOL } from '@solana/web3.js';
import { ref } from 'vue';

const connection = new Connection(clusterApiUrl('devnet'), 'confirmed');
const keypair = ref(null);
const publicKey = ref('');
const status = ref('');

function generateWallet() {
    const newKeypair = Keypair.generate();
    keypair.value = newKeypair;
    publicKey.value = newKeypair.publicKey.toBase58();
    status.value = 'Wallet generated! Ready to airdrop.';
}

async function airdropSol() {
    if (!keypair.value) return;

    try {
        status.value = 'Requesting airdrop...';
        const sig = await connection.requestAirdrop(keypair.value.publicKey, LAMPORTS_PER_SOL);
        await connection.confirmTransaction(sig, 'confirmed');
        status.value = '✅ Airdrop successful!';
    } catch (err) {
        console.error(err);
        status.value = '❌ Airdrop failed.';
    }
}
</script>

<style scoped lang="scss">
@use '@/assets/scss/abstracts/variables' as *;
@use '@/assets/scss/global' as *;

code {
    background-color: #f5f5f5;
    padding: 0.25em 0.5em;
    border-radius: 4px;
}
</style>
